import React, { useEffect, useState } from 'react';
import { MDBBtn, MDBCol, MDBInput, MDBModalBody, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow } from 'mdb-react-ui-kit';
import { logEvent, saveStaff } from '../../services/classApiServices.js';
import {
    isEmail,
    isEmpty,
} from "../../validators/helper.js";
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../../hooks/useAnalytics.js';
import Select from 'react-select';
import { useAccess } from '../../context/AccessContext.js';

function CreateTrainer(props) {
    // State to store form data
      const { trackButtonClick } = useAnalytics();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        firstname: "",
        lastname: "",
        username: "",
        password1: "",
        number: "",
        gender: "",
        age: "",
        role: "admin",
        rolevalues: [3],
    });

    const [error, setError] = useState({});
    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("trainers")

    useEffect(() => {

        function fetchData() {
            if (!props.trainerinfo) return;

            console.log(props.trainerinfo, '777777777777777');

           
            setFormData(props.trainerinfo)


        }

        fetchData();
    }, [props.campaigndata]);
    // Handle input changes
    const handleChange = (e, type) => {
        if (type == "number") {

            setFormData((prev) => ({
                ...prev,
                [type]: e,
            }));
        } else {
            const { name, value } = e.target;
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };
    const handleRole = (value) => {
        setFormData((prev) => ({
            ...prev,
            rolevalues: value,
        }));

    }

    const isAlphabetical = (str) => /^[a-zA-Z]+$/.test(str);


    let validateForm = (e) => {
        console.log("Validating form...");
        let errors = {};

        if (!isEmail(formData.email)) {
            errors.email = "Please enter valid email";
        }

        if (isEmpty(formData.username)) {
            errors.username = "Username can't be blank";
        }
        if (isEmpty(formData.firstname)) {
            errors.firstname = "First Name can't be blank";
        } else if (!isEmpty(formData.firstname) && !isAlphabetical(formData.firstname)) {
            errors.firstname = "Name can be only Alhabets  ";
        }
        if (isEmpty(formData.lastname)) {
            errors.lastname = "Last Name can't be blank";
        } else if (!isEmpty(formData.lastname) && !isAlphabetical(formData.lastname)) {
            errors.lastname = "Name can be only Alhabets  ";
        }
        if (isEmpty(formData.number)) {
            errors.number = "Contact Number can't be blank";
        } else if (!isValidPhoneNumber(formData.number)) {
            errors.number = "Please enter valid Contact Number";
        }
        // if ((formData.password1.length>6)) {
        //     errors.password1 = "password should be m";
        // }

        console.log(errors);
        if (isEmpty(errors)) {
            return true;
        } else {
            return errors;
        }
    };

    function setUserSession(userInfo) {
        localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
    }

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const fullName = userInfo?.name || `${userInfo?.fname || ""} ${userInfo?.lname || ""}`.trim() || "User";
        const username1 = userInfo.email || "Guest";
        const gymid = userInfo.gymid || "";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        const updates = {
            fname: formData.firstname,
            lname: formData.lastname,
            username: formData.username,
            password: formData.password1,
            number: formData.number,
            gender: formData.gender,
            age: formData.age,
            email: formData.email,
            role: formData.role,
            rolevalues: formData.rolevalues,
            _id: formData._id ? formData._id : -1,
        };
        let errors = validateForm();
        if (errors === true) {
            const saverep = await saveStaff(updates, gymid);

            // Log activity
            const action = updates._id !== -1 ? "updated" : "created";
            const flag = `Staff (${updates.username}) was ${action} by (${fullName})`;
            props.onSave(flag);
            await logEvent(
                {
                    Eventtype: username1,
                    username1,
                    fullName,
                    ip,
                    flag,
                    browserinfo,
                    gymid,
                    isclass: true
                },
                gymid
            );
            await trackButtonClick("CreateTrainer", updates._id !== -1 ? "Update_Trainer" : "Create_Trainer", "staff", {});
            const userInfo = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")) : "";
            if (userInfo._id == props.sId) {
                userInfo.fname = formData.firstname;
                userInfo.lname = formData.lastname;
                userInfo.name = formData.firstname + " " + formData.lastname;
                userInfo.username = formData.username;
                userInfo.number = formData.number;
                userInfo.email = formData.email;
                userInfo.role = formData.role;
                userInfo.rolevalues = formData.rolevalues
                setUserSession(userInfo);
            }
            window.location.reload(true);
        } else {
            setError(errors);
        }
    };
    const roleOptions = [
        { value: 1, label: 'Owner' },
        { value: 2, label: 'Manager' },
        { value: 3, label: 'Trainer' },
        { value: 4, label: 'FrontDesk' },
        { value: 5, label: 'Accountant' },
        { value: 6, label: 'CampaignManager' }
    ];
    return (
        <div>
            <MDBModalHeader>
                <MDBModalTitle>{props.trainerinfo ? "Update Trainer" : "Add New Trainer"}</MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={props.onclose}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
                <MDBRow>
                    
                    <MDBCol md={6} sm={12}>
                        <label>First Name<span className="text-danger">*</span></label>
                        <MDBInput
                            // className="gym-input user-pdng"
                            type="text"
                            name="firstname"
                            required=""
                            placeholder='Enter First Name'
                            value={formData.firstname}
                            onChange={handleChange}
                        />
                        {error.firstname && (
                            <>
                                <p className="clr-red">{error.firstname}</p>
                            </>
                        )}
                    </MDBCol>

                    <MDBCol md={6} sm={12}>
                        <label>Last Name<span className="text-danger">*</span></label>
                        <MDBInput
                            // className="gym-input user-pdng"
                            type="text"
                            name="lastname"
                            required=""
                            value={formData.lastname}
                            placeholder='Enter Last Name'
                            onChange={handleChange}
                        />
                        {error.lastname && (
                            <>
                                <p className="clr-red">{error.lastname}</p>
                            </>
                        )}
                    </MDBCol>


                    <MDBCol md={6} sm={12} className="pt-4">
                        <label>User Name<span className="text-danger">*</span></label>
                        <MDBInput
                            type="text"
                            name="username"
                            required=""
                            placeholder='Enter User Name'
                            value={formData.username}
                            onChange={handleChange}
                        />
                        {error.username && (
                            <>
                                <p className="clr-red">{error.username}</p>
                            </>
                        )}
                    </MDBCol>

                    <MDBCol md={6} sm={12} className="pt-4">
                        <label>Password<span className="text-danger">*</span></label>
                        <MDBInput
                            type="password"
                            name="password1"
                            required=""
                            placeholder='Enter a Password'
                            value={formData.password1}
                            maxLength={10}
                            minLength={6}
                            onChange={handleChange}
                        />
                        {error.password1 && (
                            <>
                                <p className="clr-red">{error.password1}</p>
                            </>
                        )}
                    </MDBCol>

                    <MDBCol md={6} sm={12} className="pt-4">
                        <label>Gender</label>
                        <select
                            name="gender"
                            id="gender"
                            className="gym-input user-pdng form-select"
                            value={formData.gender}
                            onChange={handleChange}
                        >
                            <option value="Male" default>
                                Male
                            </option>
                            <option value="Female">Female</option>
                        </select>
                    </MDBCol>

                    <MDBCol md={6} sm={12} className="pt-4">
                        <label>Age</label>
                        <MDBInput
                            type="text"
                            name="age"
                            required=""
                            placeholder='Enter Age'
                            value={formData.age}
                            onChange={handleChange}
                        />
                        {error.age && (
                            <>
                                <p className="clr-red">{error.age}</p>
                            </>
                        )}
                    </MDBCol>
                </MDBRow>


                <div className="mt-2">
                    <label htmlFor="email" className="fw-bold mb-2">
                        Email
                    </label>
                    <MDBInput
                        type="text"
                        name="email"
                        placeholder="Enter Email Address"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {error.email && (
                        <>
                            <p className="clr-red">{error.email}</p>
                        </>
                    )}
                </div>

                <div className="mt-2">
                    <label htmlFor="number" className="fw-bold mb-2">
                        Phone
                    </label>
                    <PhoneInput
                        className="form-control"
                        defaultCountry="IN"
                        placeholder="Enter phone number"
                        value={formData.number}
                        onChange={(value) => handleChange(value, "number")}
                    />
                    {error.number && (
                        <>
                            <p className="clr-red">{error.number}</p>
                        </>
                    )}
                </div>

                {roleAccess?.edittrainer == 1 && <div className="mt-2">
                    <label htmlFor="role" className="fw-bold mb-2">
                        Role
                    </label>

                    <Select
                        isMulti
                        options={roleOptions}
                        value={roleOptions.filter(option =>
                            formData.rolevalues.includes(option.value)
                        )}
                        onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions.map(option => option.value);
                            handleRole(selectedValues);
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select roles..."
                    />
                </div>}
            </MDBModalBody >
            <MDBModalFooter className="pe-2 pb-2">
                <MDBBtn color="secondary" onClick={props.onclose}>
                    Close
                </MDBBtn>
                <MDBBtn onClick={handleSubmit}>{props.trainerinfo ? "Update" : "Add"}</MDBBtn>
            </MDBModalFooter>
        </div >
    );
}

export default CreateTrainer;
